import axios from 'axios'

class KSPService {
    constructor() {
        this.api = axios.create({
            baseURL: process.env.VUE_APP_SET_HOST,
        });
    }

    createOrder(sendDate) {
        return this.api.post(`/orders`, sendDate);
    }

    getPerformanceCard(performanceID) {
        return this.api.get(`/basis/event?performanceId=${performanceID}`);
    }

    getPerformanceHallPlan(performanceID) {
        return this.api.get(`/basis/sections?performanceId=${performanceID}`);
    }

    getPerformanceTickets(performanceID, sectionID) {
        return this.api.get(`/basis/places?performanceId=${performanceID}&sectionId=${sectionID}`);
    }
}

export default KSPService;
